import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addbonustype',
  templateUrl: './addbonustype.component.html',
  styleUrls: ['./addbonustype.component.css']
})
export class AddbonustypeComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;


  formname: String = "BonusType";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  bonustypeColl: any = [];
  bonustypeBO: any = {};

  bonustypeid: number = 0

  bonustypeform = new FormGroup({
    bonustypeid: new FormControl(0),
    bonustypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.bonustypeid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }


    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.bonustypeform.reset();
      this.fnInitializeFormGroup();

      if (this.bonustypeid > 0) {
        this.fngetBonusType();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.bonustypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }

  fnInitializeFormGroup() {
    this.bonustypeform.setValue({
      bonustypeid: 0,
      bonustypename: '',
      inactive: false
    })
  }

  //Get 
  fngetBonusType() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'bonustypeid': this.bonustypeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getBonusType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            this.bonustypeColl = res.json().result;
            var editdata = this.bonustypeColl[0];
            this.bonustypeBO=editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;        
    } 
      this.submitted = true;
      this.successfully = false;
      //Validate
      this.saveloading = true;


      if (this.bonustypeform.valid) {
        //Check
        var data = {
          'bonustypeid': this.bonustypeid,
          'bonustypename': this.bonustypeform.get('bonustypename').value,
          'inactive': this.bonustypeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckBonusType(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.bonustypeform.get('bonustypeid').value > 0) {
                  //Update 
                  this.fnSetBonusType(data);
                }
                else {
                  //Insert 
                  this.fnInsertBonusType(data);
                }
              }
              else {
               

                if (_checkresult === "name") {
                  this.saveloading = false;
                  this.bonustypeform.controls['bonustypename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertBonusType(data) {

    this.appService.fnInsertBonusType(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new bonustype has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.bonustypename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetBonusType(data) {

    this.appService.fnSetBonusType(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The bonustype has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.bonustypeid, data.bonustypename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/BonusType']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.bonustypeform.setValue({
      bonustypeid: deptBO.bonustypeid,
      bonustypename: deptBO.bonustypename,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
